// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import CONFIG from './config'
// Vue Router
import VueRouter from 'vue-router'
import { sync } from 'vuex-router-sync'
import routes from './routes'
// Vue Apollo
import { apollo } from './apollo'
import VueApollo from 'vue-apollo'
// Store
import store from './store'
// Vue Material
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'
import themes from './config/themes'
// Vue i18n
import VueI18n from 'vue-i18n'
// Momentjs
import VueMoment from 'vue-moment'
import 'moment/locale/sk'
// Validator
import Vuelidate from 'vuelidate'

// Vue use
Vue.use(VueRouter)
Vue.use(VueApollo)
Vue.use(VueMaterial)
Vue.use(VueI18n)
Vue.use(VueMoment)
Vue.use(Vuelidate)

// Vue material
Vue.material.registerTheme(themes)

// Apollo client
const apolloProvider = new VueApollo({
  defaultClient: apollo
})

// i18n
import i18nMessages from './i18n'
const i18n = new VueI18n({
  locale: store.state.settings.locale,
  fallbackLocale: CONFIG.locale.fallback,
  messages: i18nMessages
})
// auto update locale
store.subscribe((mutation, state) => {
  if (mutation.type === 'settings/setLocale') {
    i18n.locale = store.state.settings.locale
  }
})

// Utils
import JWT from './utils/jwt'
import './utils/filters'

// Router
const router = new VueRouter({
  routes,
  mode: 'history'
})
sync(store, router)

// Auth
router.beforeEach((to, from, next) => {
  const token = store.state.auth.token
  let forceLogout = false

  if (to.meta.auth && !token) {
    next({ name: 'login' })
  } else {
    if (token) {
      // check token
      store.dispatch('auth/check').then((response) => {
        if (!response.success) {
          store.dispatch('auth/logout')
          next({ name: 'login' })
        }
      }).catch(() => {
        store.dispatch('auth/logout')
        next({ name: 'login' })
      })

      // if expired logout + redirect
      if (JWT.isExpired(token)) forceLogout = true
    }

    // forceLogout
    if (forceLogout) {
      store.dispatch('auth/logout')
      next({ name: 'login' })
    } else next() // router next
  }
})

// SCSS
import 'roboto-fontface/css/roboto/sass/roboto-fontface.scss'
import 'material-design-icons-iconfont/dist/material-design-icons.scss'
import './assets/css/fontello.css'

// Mount Vue
import AppTemplate from './App.vue'
const App = Vue.extend(AppTemplate)

new App({
  store,
  router,
  apolloProvider,
  i18n
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js